import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import about3 from "../assets/about3.png"
import { FaLinkedinIn } from "react-icons/fa";
import { Link } from 'react-router-dom'
import about2 from '../assets/about2.png'
import about1 from '../assets/about1.png'

const About = () => {
    return (
        <div className="animate-fade">
            <Header />
            <div className="z-[-1] mt-[60px] lg:mt-auto relative">
                <img src={about3} className="w-[100vw] h-[400px] object-cover object-left top-0 left-[50%]" alt="Office building interior" />
                <h1 className="text-[white] font-bold text-[1.5em] lg:text-[2.1em] m-[2em] uppercase absolute left-[10%] top-[50%] lg:top-[210px] z-1">Our Leadership Team</h1>
            </div>

            <div className="w-11/12 mx-auto relative text-center items-center">
                <section className="flex flex-col lg:flex-row mb-[4em] mt-[3em] w-[90%] lg:w-[80%] mx-auto">
                    <div className="flex flex-col lg:mr-[5em]">
                        <h2 className="relative z-[-1] text-left lg:text-right font-semibold mt-[1em] text-[1.3em]">Insoo Kim</h2>

                        <div className="text-left lg:text-right text-[0.95em] leading-[1.8em]">
                            <p className="relative z-[-1] my-[2em]">Insoo Kim is the President and Founder of ALKOR Semicon Total Solutions Inc. He graduated in 1991 with a B.S. in Metallurgical Engineering.</p>

                            <p className="relative z-[-1] my-[2em]">In 2002, Kim joined Samsung Electronics in South Korea as the Purchasing Manager of Semiconductor Raw
                                Materials, later relocating to Samsung Austin Semiconductor to become the Purchasing Sr. Manager. He also has
                                three years of experience as the Lead Sourcing Manager of Fab8 at GlobalFoundries in Malta, New York.</p>

                            <p className="relative z-[-1] my-[2em]">In 2013, Insoo Kim started ALKOR Semicon Total Solutions Inc. and has been connecting
                                semiconductor companies in both the United States and South Korea for over a decade.</p>
                            <div className="flex flex-row items-center lg:justify-end">
                                <p>Connect with Insoo: &emsp;</p>
                                <Link to="https://www.linkedin.com/in/insoo-kim-97819014/" className="hover:text-ocean text-[1.5em]">
                                    <FaLinkedinIn size={20} />
                                </Link>
                            </div>
                        </div>
                    </div>

                    <img src={about2} className="hidden lg:block w-[35%] h-fit mt-[1em]" width="1080" height="1080" alt="Laptops and graphs" />
                </section>
                <hr className="mx-auto w-[80%] h-[1px] border-0 border-t-[2px] border-slate my-[2em]"></hr>
                <section className="flex flex-col lg:flex-row mb-[4em] mt-[3em] w-[90%] lg:w-[80%] mx-auto">
                    <div className="flex flex-col lg:mr-[5em]">
                        <h2 className="text-left lg:text-right font-semibold mt-[1em] text-[1.3em]">Hee Ran Kim</h2>

                        <div className="text-left lg:text-right text-[0.95em] leading-[1.8em]">
                            <p className="my-[2em]">Hee Ran Kim is the CFO of ALKOR Semicon Total Solutions Inc. She received her B.S. in Chemistry in 1995.</p>

                            <p className="my-[2em]">In 1995, Kim joined Samsung Electronics in South Korea and worked as a Process Engineer for five years.
                                She joined ALKOR Semicon Total Solutions Inc. later in 2013 as the Chief Financial Officer, bringing her diverse qualifications and skills to the company.</p>
                        </div>
                    </div>

                    <img src={about1} className="hidden lg:block w-[35%] h-fit mt-[1em]" width="1080" height="1080" alt="Company workers and laptops" />
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default About;



